<template>
  <el-dialog
    :title="$t('accountBond.editBond')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="resetForm"
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item :label="$t('accountBond.shopType')">
        <el-input v-model="form.bondName" disabled />
      </el-form-item>
      <el-form-item :label="$t('accountBond.bondName')">
        <el-input v-model="form.bondName" disabled />
      </el-form-item>
      <el-form-item :label="$t('accountBond.amount')" prop="amount">
        <el-input v-model="form.amount" :placeholder="$t('accountBond.inputAmount')" />
      </el-form-item>
      <el-form-item :label="$t('accountBond.bondMonth')">
        <el-input v-model="form.bondMonth" :placeholder="$t('accountBond.inputBondMonth')" />
      </el-form-item>
      <el-form-item :label="$t('accountBond.remark')">
        <el-input v-model="form.remark" type="textarea" :placeholder="$t('accountBond.inputRemark')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editAccountBond">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAccountBond } from '@/api/admin/accountBondApi'

export default {
  name: 'EditAccountBond',
  data() {
    return {
      dialogVisible: false,
      form: {
        bondId: '',
        bondName: '',
        amount: '',
        bondMonth: '',
        bondType: '6006',
        objId: '',
        remark: ''
      },
      rules: {
        amount: [
          { required: true, message: this.$t('accountBond.amountRequired'), trigger: 'blur' },
          { min: 1, max: 10, message: this.$t('accountBond.amountFormat'), trigger: 'blur' }
        ],
        bondId: [
          { required: true, message: this.$t('accountBond.bondIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.form = { ...row }
      this.dialogVisible = true
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.form = {
        bondId: '',
        bondName: '',
        amount: '',
        bondMonth: '',
        bondType: '6006',
        objId: '',
        remark: ''
      }
    },
    async editAccountBond() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updateAccountBond(this.form)
            this.$message.success(this.$t('accountBond.editSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>